import { clsx } from 'clsx';

/**
 * Логотип ION — единый SVG-блок: красная точка + жирная "i" + "on" вплотную.
 * Пропорции и масштабы — как на референсе бренда.
 */
export const Logo = ({
  variant = 'light',
  className,
  withWordmark = true,
}: {
  variant?: 'light' | 'dark';
  className?: string;
  withWordmark?: boolean;
}): React.JSX.Element => {
  // На тёмном фоне буквы белые, на светлом — почти чёрные.
  const textColor = variant === 'light' ? '#FFFFFF' : '#0F0F12';

  // Без надписи — только квадратный знак (для favicon-style).
  if (!withWordmark) {
    return (
      <svg
        viewBox="0 0 64 64"
        className={clsx('w-8 h-8', className)}
        xmlns="http://www.w3.org/2000/svg"
        aria-label="ION"
      >
        <circle cx="32" cy="14" r="8" fill="#E11D2A" />
        <rect x="24" y="26" width="16" height="32" rx="2" fill={textColor} />
      </svg>
    );
  }

  // Полный wordmark "ion".
  // viewBox 280×140 → точка крупная (r=22), палочка "i" 24×82,
  // тут же текст "on" Inter Black, вплотную.
  return (
    <svg
      viewBox="0 0 280 140"
      className={clsx('h-9 w-auto', className)}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="ION"
      role="img"
    >
      {/* красная точка над "i" */}
      <circle cx="40" cy="22" r="22" fill="#E11D2A" />
      {/* палочка "i" */}
      <rect x="26" y="52" width="28" height="84" rx="3" fill={textColor} />
      {/* "on" — нативный SVG-текст в Inter, тот же цвет, что палочка */}
      <text
        x="68"
        y="136"
        fill={textColor}
        fontFamily="Inter, -apple-system, BlinkMacSystemFont, system-ui, sans-serif"
        fontWeight="900"
        fontSize="132"
        letterSpacing="-3"
      >
        on
      </text>
    </svg>
  );
};
